import React, { Component } from 'react'

import PropTypes from 'prop-types'

import Places from 'react-places-autocomplete'

export default class PlacesAutocomplete extends Component {
  static propTypes = {
    inputProps: PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      onChange: PropTypes.func.isRequired
    }),
    options: PropTypes.shape({
      types: PropTypes.arrayOf(PropTypes.string)
    }),
    classNames: PropTypes.shape({
      root: PropTypes.string,
      input: PropTypes.string,
      autocompleteContainer: PropTypes.string
    }),
    onSelect: PropTypes.func.isRequired,
    onError: PropTypes.func
  }

  static defaultProps = {
    onError: () => ({}),
    classNames: {
      root: 'col-md-9',
      input: 'form-control create-poi__form-input',
      autocompleteContainer: 'create-poi__autocomplete-container'
    }
  }

  render() {
    const { inputProps, options, classNames, onError, onSelect } = this.props

    return (
      <Places
        inputProps={inputProps}
        options={options}
        onError={onError}
        onSelect={(place, placeId) => onSelect(place, placeId)}
        classNames={classNames}
      />
    )
  }
}



// WEBPACK FOOTER //
// src/components/Event/PlacesAutocomplete.js